import styled from 'styled-components';

export const FloatingFlexArea = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const FloattingInnerArea = styled.div`
  width: 100%;
  align-self: flex-end;
  margin: auto 0 16px 0;

  padding: 8px;
`;
